import { VIETNAMESE } from '../../../assets/images';
import { Section, TableOfContent } from '../../../typings/interfaces';
// Vietnamese
const VISection: Section[] = [
  {
    name: '1: Tài liệu tham khảo và tổng quan',
    subSections: [
      {
        name: 'Mở đầu',
        page: 3,
      },
      {
        name: 'Mục đích và ứng dụng của hướng dẫn tại chỗ',
        page: 4,
      },
      {
        name: 'Các định nghĩa chính',
        page: 5,
      },
      {
        name: 'Thang kiểm soát',
        page: 6,
      },
    ],
  },
  {
    name: '2: LIFESavers',
    subSections: [
      {
        name: 'Xe cơ giới – An toàn giao thông',
        page: 9,
      },
      {
        name: 'Làm việc ở trên cao',
        page: 12,
      },
      {
        name: 'Thiết bị di động chạy điện (MPE)',
        page: 18,
      },
      {
        name: 'Khóa/gắn thẻ báo khóa/Cách ly năng lượng',
        page: 22,
      },
      {
        name: 'Công việc về điện',
        page: 25,
      },
      {
        name: 'Không gian hạn chê',
        page: 29,
      },
      {
        name: 'Vật liệu chất đống và bảo quản',
        page: 32,
      },
      {
        name: 'An toàn ô tô ray',
        page: 37,
      },
      {
        name: 'Công việc đào xới và tạo rãnh',
        page: 41,
      },
      {
        name: 'Nâng và chằng buộc',
        page: 44,
      },
      {
        name: 'Vật liệu nguy hiểm',
        page: 49,
      },
      {
        name: 'Công việc sinh nhiệt',
        page: 52,
      },
    ],
  },
  {
    name: '3: Tài nguyên và công cụ bổ sung',
    subSections: [
      {
        name: 'Làm việc ở trên và quanh môi trường nước',
        page: 56,
      },
      {
        name: 'Vật thể rơi hoặc đổ',
        page: 59,
      },
      {
        name: 'Kiểm tra không khí/khí',
        page: 61,
      },
      {
        name: 'Liên lạc về mối nguy hiểm của hóa chất',
        page: 65,
      },
    ],
  },
  {
    name: '4: Phương pháp quản lý an toàn của Cargill',
    subSections: [
      {
        name: 'Thuật ngữ chính',
        page: 70,
      },
      {
        name: 'Phương pháp quản lý an toàn của Cargill',
        page: 72,
      },
      {
        name: 'Phân loại tai nạn có thể gây thương tích nghiêm trọng và tử vong (SIFp)',
        page: 73,
      },
      {
        name: 'Bảng tiêu chí tự động xác định SIF',
        page: 74,
      },
      {
        name: 'Hiệu suất của con người và tổ chức (HOP)',
        page: 76,
      },
    ],
  },
];

const VITableOfContent: TableOfContent = {
  language: 'vi',
  sections: VISection,
  label: 'Mục lục',
  pdfLink: 'https://en-pdfs-life-on-focus.dev.cglcloud.in/Cargill Field Safety Guide (vi_VN)_DIGITAL_CROPPED.pdf',
  hopPocket: 'Hướng dẫn bỏ túi HOP',
  hopPocketLink: 'https://en-pdfs-life-on-focus.dev.cglcloud.in/HOP pocket guide content 2021-09-08_Vietnamese.pdf',
  source: VIETNAMESE,
};

export default VITableOfContent;
